import { createFeatureSelector, createSelector } from '@ngrx/store';
import { headerCreateMenuFeatureKey } from '@api-ui-app/src/app/header-create-menu/+state/header-create-menu.reducer';
import { State } from './header-create-menu.reducer';

export const getState = createFeatureSelector<State>(headerCreateMenuFeatureKey);

export const getIsLoading = createSelector(getState, state => state.isLoading);
export const getUploadedDesignsCount = createSelector(getState, state => state.uploadedDesignsCount);
